module.exports = __webpack_public_path__ + "img/fun_m_5.90dc1a74.png";